import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { useState, useEffect } from 'react';


interface NameProps {
    formPrefix: string;
    outputFirstName: (fname: string) => void;
    outputMiddleName: (mname: string) => void;
    outputLastName: (lname: string) => void;
}

function FullNameBlock({formPrefix, outputFirstName, outputMiddleName, outputLastName}: NameProps){
    let [firstname, setFirstname] = useState("");
    let [middlename, setMiddleName] = useState("");
    let [lastname, setLastname] = useState("");

    /* Component Init */
    useEffect(() => {
        outputFirstName(firstname)
        outputLastName(lastname)
    }, [firstname, middlename, lastname]);

    return (
        <> 
            <Row className="">
                <Col md={{span: 6}}>
                    <div className="brand-tertiary-color-border">
                        <input placeholder="Firstname *" type="text" className="border-0 input-fill no-generic-input-styles brand-tertiary-color-border" id="first_name" aria-describedby="firstnameHelp" onChange={(e) => setFirstname(e.target.value)} />
                    </div>
                </Col>
                <Col md={{span: 6}}>
                    <div className="brand-tertiary-color-border">
                        <input placeholder="Lastname *" type="text" className="border-0 input-fill no-generic-input-styles" id="last_name" aria-describedby="lastnameHelp" onChange={(e) => setLastname(e.target.value)}/>
                    </div>
                </Col>
            </Row>
        </>
    )
}

export default FullNameBlock;